import React, { useState } from "react"
import "./style.scss"
import Button from "../../elements/button/Button"
import RequestDemo from "../../modals/requestdemo/RequestDemo"

const HowItWorks = ({ title, options, btnBg, btnColor }) => {
  const [showDemoModal, setShowDemoModal] = useState(false)

  const showModal = () => {
    setShowDemoModal(!showDemoModal)
  }
  const sectionData = {
    title: title,
    options,
  }
  return (
    <div className="how_it_works">
      {showDemoModal && <RequestDemo show={showDemoModal} onHide={showModal} />}
      <h1 className="title">{sectionData.title}</h1>
      <div>
        <ul
          className={`how_it_works_options ${
            options && options.length === 1 && "one"
          }`}
        >
          {sectionData.options &&
            sectionData.options.map((item, index) => (
              <li key={index}>
                <p>{item}</p>
              </li>
            ))}
        </ul>
        <div className="demo-area-btn">
          <Button
            style={{
              background: btnBg ? btnBg : "",
              color: btnColor ? btnColor : "",
            }}
            onClick={showModal}
            className="round demo"
          >
            Book Demo
          </Button>
        </div>
      </div>
    </div>
  )
}

export default HowItWorks
